import * as r from 'easit--routing';
export * from 'easit--routing';
import { translation } from 'easit--localization';

export const paths = () => {
    return {
        home: `/live`,
        search: `/live/${translation().route_Search}/:searchText?`,
        genericEventDetail: `/live/${translation().route_LiveEventDetail}`,
        eventDetail: `/live/${translation().route_LiveEventDetail}/:eventId?`,
        eventDetailPrematch: `/${translation().route_StandardEventDetail}/:eventId?`,
        favoriteDetails: `/live/${translation().route_Favorites}`,
        calendar: `/live/${translation().route_Calendar}`,
        ticketList: `/live/${translation().route_BetList}`,
        ticketListVG: `/live/${translation().route_BetListVG}`,
        ticketWinList: `/live/${translation().route_BetWinList}`,
        ticketDetail: `/live/${translation().route_TicketDetail}/:ticketId?`,
        getTicketDetailPublic(publicTicketId: string) {
            // no live
            return '/tiket/' + publicTicketId;
        },
        ticketDetailPublic: `/live/${translation().route_BetDetailPublic}/:publicTicketId?`,
        legacyTicketDetailPublic: `/live/${translation().route_LegacyTicketDetailPublic}/:publicTicketId?`,
        getLegacyTicketDetailPublic(publicTicketId: string) {
            // no live
            return `/${translation().route_LegacyTicketDetailPublic}/${publicTicketId}`;
        },
        legacyTicketDetailForTipos: `/live/moj-tiketl/:ticketId?`,  //?? TODO why?
        //getLegacyTicketDetailForTipos: (ticketId: string) => { return `/live/moj-tiketl/${ticketId}`; },
        ticketDetailByNumber: `/live/${translation().route_TicketDetailByNumber}/:ticketNumber?`,
        ticketDetailVG: `/live/${translation().route_TicketDetailVG}/:ticketId?`
    };
}

export interface IPushToEventDetailParams extends IOptionalMainMenuParams {
    eventKey: string;
    ignoreHistory?: boolean;
}

export const pushToSearch = (searchText: string) => {
    r.push(paths().search.replace(':searchText?', searchText));
}

export const pushToEventDetail = (eventId: number = 0, ignoreHistory: boolean = false, canOpenLiveStream = false, shouldPushToPrematchDetail: boolean = false) => {
    // const path = paths.eventDetail.replace(':eventId?', `${eventId}`);
    // r.push(path + (gameGroup ? '?gameGroup=' + gameGroup : ''));

    let path;
    if (eventId > 0 && !shouldPushToPrematchDetail) {
        path = paths().eventDetail.replace(':eventId?', `${eventId}`);
    }
    else if (eventId > 0 && shouldPushToPrematchDetail) {
        redirectToPrematchEventDetailFromLive({eventKey: eventId.toString()})
    }
    else {
        path = paths().eventDetail.replace(':eventId?', "");
    }
    if (canOpenLiveStream) {
        path += "?ls=1";
    }
    r.push(path, ignoreHistory);
};

export const redirectToPrematchEventDetailFromLive = (params: IPushToEventDetailParams) => {
    document.location.href = `/${translation().route_StandardEventDetail}/${params.eventKey}`;  // no hash, base link is same as link with hash
};

export const pushToFavoriteDetails = (ignoreHistory: boolean = false) => {
    let path = paths().favoriteDetails;
    r.push(path, ignoreHistory);
};

export const pushToCalendar = (ignoreHistory: boolean = false) => {
    let path = paths().calendar;
    r.push(path, ignoreHistory);
};

export function createEventDetailParams(
    params: {
        eventId: string;
    }
) {
    const result: IPushToEventDetailParams = {
        eventKey: params.eventId
    };

    return result;
}

export const pushToTicketDetail = (ticketId: string) => {
    let path = paths().ticketDetail.replace(':ticketId?', `${ticketId}`);
    r.push(path);
};

export const pushToTicketDetailForVG = (ticketId: string) => {
    let path = paths().ticketDetailVG.replace(':ticketId?', `${ticketId}`);
    r.push(path);
};

export const pushToTicketDetailByNumber = (ticketNumber: string) => {
    if (ticketNumber) {
        ticketNumber.trim();
    }
    let path = paths().ticketDetailByNumber.replace(':ticketNumber?', `${ticketNumber}`);
    r.push(path);
};

export interface IPushToEventListParams extends IOptionalMainMenuParams { }

export type IFilterParams = ITimeFilterParams | IDateFilterParams;

export interface ITimeFilterParams {
    hours?: number;
}

export interface IDateFilterParams {
    date?: Date;
}

export interface IOptionalMainMenuParams {
    categoryKey?: string;
    eventKey?: string;
    detailId?: number;
    gameId?: number;
    gameGroup?: number;
    filter?: string | number;
    filterParams?: ITimeFilterParams | IDateFilterParams;
    searchBy?: string;
    favorites?: number;
}
/*
function addParams(path: string, params: string) {
    return params && params.length > 0 ? (path.indexOf('?') === -1 ? `${path}?${params}` : `${path}&${params}`) : path;
}

const unifyDate = (value: Date, now: Date): Date => {
    if (!isTheSameDay(value, now)) {
        value.setHours(0);
        value.setMinutes(0);
        value.setSeconds(0);
    }
    return value;
};
*/
